// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainInfo-module__shadowBox--w3Yad {
    display: flex;
    margin-top: 30px;
    padding: 15px 20px;
    border-radius: 14px;
    gap: 15px;
    min-height: 45vh;
    background-color: white;
    overflow: hidden;
}

.MainInfo-module__errorText--gZLHZ {
    margin-top: 16px;
    color: red;
    font-size: 20px;
    text-align: center;
}


.MainInfo-module__rightBox--OD_9W {
    width: 50%;
}

.MainInfo-module__contentRow--ds9rp {
    display: flex;
    gap: 40px;
    border: 1px solid #6f879c4b;
    border-radius: 14px;
    padding: 8px;
    justify-content: space-between;
}

.MainInfo-module__contentRow--ds9rp:not(:first-child) {
    margin-top: 20px;
}

.MainInfo-module__contentColumn--p1ks1 {
    display: flex;
    flex-direction: column;
    width: 280px;
}

.MainInfo-module__contentColumn--p1ks1>span {
    color: #516372;
    font-size: 16px;
    font-weight: 600;
}

.MainInfo-module__contentColumn--p1ks1>p {
    color: #516372;
    margin-top: 5px;
    font-size: 16px;
}

.MainInfo-module__title--r4Lbk {
    color: #6F879C;
    font-size: 20px;
    font-weight: 400;
}

.MainInfo-module__updateBtnBox--GzAKj {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}

.MainInfo-module__icon--KKWMW>svg {
    font-size: 16px;
    display: flex
}

.MainInfo-module__icon--KKWMW {
    display: flex;
    align-items: center;
    gap: 5px;
}

.MainInfo-module__emptyPhoto--j09pT {
    background-color: #024ccb21;
    padding: 8px;
    border-radius: 14px;
}

.MainInfo-module__emptyPhotoIcon--azbfq {
    border-radius: 50%;
    background-color: #095c9f42;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 25px;
}

.MainInfo-module__emptyPhotoIcon--azbfq>svg {
    width: 100px;
    height: 100px;
    color: white;
}

.MainInfo-module__contentCurator--gMb4H {
    display: flex;
    gap: 20px;
    padding: 8px;
    align-items: center;
    border-radius: 14px;
    border: 1px solid #6f879c4b;
    position: relative;
}

.MainInfo-module__iconRole--BU1uE {
    position: absolute;
    top: -10px;
    right: 12px;
    background-color: #0054E6;
    padding: 3px 12px;
    color: white;
    font-size: 13px;
    text-align: center;
    border-radius: 14px;
    white-space: nowrap;
    z-index: 1;
}

.MainInfo-module__VIPRole--Ljn3n {
    background-color: #d37fe8;
}

.MainInfo-module__photoBox--GdShO {
    width: 100px;
    height: 150px;
    flex-shrink: 0;
}

.MainInfo-module__photoImg--JHaq3 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid #6f879c4b;
    border-radius: 14px;
}


.MainInfo-module__curatorInfo--tLb5d {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 35px;
}

.MainInfo-module__contentCurator--gMb4H:not(:first-of-type) {
    margin-top: 20px;
}

.MainInfo-module__curatorInfo--tLb5d>h4 {
    font-weight: 600;
    color: #516372;
    font-size: 16px;
}

.MainInfo-module__curatorInfo--tLb5d>p {
    color: #516372;
    font-size: 16px;
}

.MainInfo-module__curatorInfo--tLb5d>span {
    color: #0054E6;
    font-size: 16px;
    font-weight: 600;
}

.MainInfo-module__curatorInfo--tLb5d>span>svg {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 20px;
    width: 20px;
}

.MainInfo-module__leftBox--ZVM3M {
    width: 50%;
    display: flex;
    flex-direction: column;
}

.MainInfo-module__curatorInfo--tLb5d>a {
    color: #516372;
    font-size: 16px;
    text-decoration: none;
}

@media (max-width: 1030px) {
    .MainInfo-module__shadowBox--w3Yad {
        flex-direction: column;
    }

    .MainInfo-module__rightBox--OD_9W {
        border-bottom: 1px solid #6f879c4b;
    }

    .MainInfo-module__rightBox--OD_9W,
    .MainInfo-module__leftBox--ZVM3M {
        width: 100%;
        border-right: none;
    }
}

@media (max-width: 550px) {
    .MainInfo-module__contentRow--ds9rp {
        flex-direction: column;
        gap: 0 !important;
        margin-top: 5px;
    }
}


.MainInfo-module__copyContainer--zhfKp {
    position: relative;
    display: inline-block;
    width: 100%;
}

.MainInfo-module__copyableText--M1ND3 {
    cursor: pointer;
    transition: color 0.2s;
    user-select: none;
}

.MainInfo-module__copyableText--M1ND3:hover {
    color: #0054E6;
}

.MainInfo-module__copyableText--M1ND3:active {
    opacity: 0.6;
}

.MainInfo-module__tooltip--Bv8Dk {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: calc(100% + 10px);
    background: #333;
    color: #fff;
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 13px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s ease;
    transform: translateX(-50%) translateY(4px);
    display: flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 100;
}

.MainInfo-module__tooltip--Bv8Dk::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #333;
}

.MainInfo-module__tooltipVisible--EpcCj {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
}

.MainInfo-module__checkIcon--apYan {
    font-size: 16px !important;
    color: #4caf50;
}

.MainInfo-module__marginTop--ssyYU {
    margin-top: 20px;
}

.MainInfo-module__oneLine--pkaY3 {
    display: flex;
    gap: 20px;
}

@media (max-width: 1360px) {
    .MainInfo-module__oneLine--pkaY3 {
        display: flex;
        flex-direction: column;
        gap: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/contract-page/ui/styles/MainInfo.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;;QAEI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,iBAAiB;QACjB,eAAe;IACnB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,oDAAoD;IACpD,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;AACJ","sourcesContent":[".shadowBox {\r\n    display: flex;\r\n    margin-top: 30px;\r\n    padding: 15px 20px;\r\n    border-radius: 14px;\r\n    gap: 15px;\r\n    min-height: 45vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n\r\n.errorText {\r\n    margin-top: 16px;\r\n    color: red;\r\n    font-size: 20px;\r\n    text-align: center;\r\n}\r\n\r\n\r\n.rightBox {\r\n    width: 50%;\r\n}\r\n\r\n.contentRow {\r\n    display: flex;\r\n    gap: 40px;\r\n    border: 1px solid #6f879c4b;\r\n    border-radius: 14px;\r\n    padding: 8px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.contentRow:not(:first-child) {\r\n    margin-top: 20px;\r\n}\r\n\r\n.contentColumn {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 280px;\r\n}\r\n\r\n.contentColumn>span {\r\n    color: #516372;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.contentColumn>p {\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 16px;\r\n}\r\n\r\n.title {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n}\r\n\r\n.updateBtnBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.icon>svg {\r\n    font-size: 16px;\r\n    display: flex\r\n}\r\n\r\n.icon {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n\r\n.emptyPhoto {\r\n    background-color: #024ccb21;\r\n    padding: 8px;\r\n    border-radius: 14px;\r\n}\r\n\r\n.emptyPhotoIcon {\r\n    border-radius: 50%;\r\n    background-color: #095c9f42;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    top: 25px;\r\n}\r\n\r\n.emptyPhotoIcon>svg {\r\n    width: 100px;\r\n    height: 100px;\r\n    color: white;\r\n}\r\n\r\n.contentCurator {\r\n    display: flex;\r\n    gap: 20px;\r\n    padding: 8px;\r\n    align-items: center;\r\n    border-radius: 14px;\r\n    border: 1px solid #6f879c4b;\r\n    position: relative;\r\n}\r\n\r\n.iconRole {\r\n    position: absolute;\r\n    top: -10px;\r\n    right: 12px;\r\n    background-color: #0054E6;\r\n    padding: 3px 12px;\r\n    color: white;\r\n    font-size: 13px;\r\n    text-align: center;\r\n    border-radius: 14px;\r\n    white-space: nowrap;\r\n    z-index: 1;\r\n}\r\n\r\n.VIPRole {\r\n    background-color: #d37fe8;\r\n}\r\n\r\n.photoBox {\r\n    width: 100px;\r\n    height: 150px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.photoImg {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border: 1px solid #6f879c4b;\r\n    border-radius: 14px;\r\n}\r\n\r\n\r\n.curatorInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    height: 35px;\r\n}\r\n\r\n.contentCurator:not(:first-of-type) {\r\n    margin-top: 20px;\r\n}\r\n\r\n.curatorInfo>h4 {\r\n    font-weight: 600;\r\n    color: #516372;\r\n    font-size: 16px;\r\n}\r\n\r\n.curatorInfo>p {\r\n    color: #516372;\r\n    font-size: 16px;\r\n}\r\n\r\n.curatorInfo>span {\r\n    color: #0054E6;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.curatorInfo>span>svg {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    align-content: center;\r\n    height: 20px;\r\n    width: 20px;\r\n}\r\n\r\n.leftBox {\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.curatorInfo>a {\r\n    color: #516372;\r\n    font-size: 16px;\r\n    text-decoration: none;\r\n}\r\n\r\n@media (max-width: 1030px) {\r\n    .shadowBox {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .rightBox {\r\n        border-bottom: 1px solid #6f879c4b;\r\n    }\r\n\r\n    .rightBox,\r\n    .leftBox {\r\n        width: 100%;\r\n        border-right: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 550px) {\r\n    .contentRow {\r\n        flex-direction: column;\r\n        gap: 0 !important;\r\n        margin-top: 5px;\r\n    }\r\n}\r\n\r\n\r\n.copyContainer {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n\r\n.copyableText {\r\n    cursor: pointer;\r\n    transition: color 0.2s;\r\n    user-select: none;\r\n}\r\n\r\n.copyableText:hover {\r\n    color: #0054E6;\r\n}\r\n\r\n.copyableText:active {\r\n    opacity: 0.6;\r\n}\r\n\r\n.tooltip {\r\n    position: absolute;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    bottom: calc(100% + 10px);\r\n    background: #333;\r\n    color: #fff;\r\n    padding: 6px 14px;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    transition: opacity 0.25s ease, transform 0.25s ease;\r\n    transform: translateX(-50%) translateY(4px);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    z-index: 100;\r\n}\r\n\r\n.tooltip::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    border: 6px solid transparent;\r\n    border-top-color: #333;\r\n}\r\n\r\n.tooltipVisible {\r\n    opacity: 1;\r\n    transform: translateX(-50%) translateY(0);\r\n}\r\n\r\n.checkIcon {\r\n    font-size: 16px !important;\r\n    color: #4caf50;\r\n}\r\n\r\n.marginTop {\r\n    margin-top: 20px;\r\n}\r\n\r\n.oneLine {\r\n    display: flex;\r\n    gap: 20px;\r\n}\r\n\r\n@media (max-width: 1360px) {\r\n    .oneLine {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 0px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shadowBox": `MainInfo-module__shadowBox--w3Yad`,
	"errorText": `MainInfo-module__errorText--gZLHZ`,
	"rightBox": `MainInfo-module__rightBox--OD_9W`,
	"contentRow": `MainInfo-module__contentRow--ds9rp`,
	"contentColumn": `MainInfo-module__contentColumn--p1ks1`,
	"title": `MainInfo-module__title--r4Lbk`,
	"updateBtnBox": `MainInfo-module__updateBtnBox--GzAKj`,
	"icon": `MainInfo-module__icon--KKWMW`,
	"emptyPhoto": `MainInfo-module__emptyPhoto--j09pT`,
	"emptyPhotoIcon": `MainInfo-module__emptyPhotoIcon--azbfq`,
	"contentCurator": `MainInfo-module__contentCurator--gMb4H`,
	"iconRole": `MainInfo-module__iconRole--BU1uE`,
	"VIPRole": `MainInfo-module__VIPRole--Ljn3n`,
	"photoBox": `MainInfo-module__photoBox--GdShO`,
	"photoImg": `MainInfo-module__photoImg--JHaq3`,
	"curatorInfo": `MainInfo-module__curatorInfo--tLb5d`,
	"leftBox": `MainInfo-module__leftBox--ZVM3M`,
	"copyContainer": `MainInfo-module__copyContainer--zhfKp`,
	"copyableText": `MainInfo-module__copyableText--M1ND3`,
	"tooltip": `MainInfo-module__tooltip--Bv8Dk`,
	"tooltipVisible": `MainInfo-module__tooltipVisible--EpcCj`,
	"checkIcon": `MainInfo-module__checkIcon--apYan`,
	"marginTop": `MainInfo-module__marginTop--ssyYU`,
	"oneLine": `MainInfo-module__oneLine--pkaY3`
};
export default ___CSS_LOADER_EXPORT___;
